<template>
  <div class="user-avator-dropdown">
    <Poptip placement="bottom-end" trigger="click" class="avatar-container right-menu-item hover-effect" popper-class="dropdown-user-menu">
      <div slot="content">
        <ul class="dropdown-menu">
          <li class="user-header">
            <img v-if="avatar" :src="avatar" class="avatar" alt="更换头像">
            <p>
              {{ userInfo.realname }} ({{ userInfo.username }})
              <small>共登录: {{ userInfo.loginCount || 0 }} 次</small>
              <small>上次登录: {{ userInfo.lastLoginTime |formatDate }}</small>
            </p>
          </li>
          <li v-if="userInfo.warehouse || userInfo.warehouse_id" class="user-body">
            <div style="margin: 0 15px">
              <p><b>商店代码:</b> {{ userInfo.warehouse.warehouse_code }} </p>
              <p><b>商店名称:</b> {{ userInfo.warehouse.warehouse_name }}</p>
            </div>
          </li>
          <li class="user-footer">
            <div class="pull-left">
              <Button type="info" size="small" @click="userCenter">个人中心</Button>
            </div>
            <div class="pull-right">
              <Button type="error" size="small" @click="logout">退出登录</Button>
            </div>
          </li>
        </ul>
      </div>
      <Badge><Avatar :src="userAvator"/></Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
    </Poptip>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout () {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    userCenter () {
      this.$router.push({
        name: 'user_center'
      })
    }
  }
}
</script>
<style lang="less">
  .avatar-container {
    margin-right: 16px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -15px;
        top: 13px;
        font-size: 14px;
      }
    }
  }
  .dropdown-user-menu {
    padding: 0;
    top: 50px !important;
    .ivu-poptip-body {
      padding: 0;
    }
    .ivu-poptip-arrow:after {
      border-bottom-color: #56a8fc !important;
      top: 0 !important;
    }
    .dropdown-menu {
      border-radius: 5px;
      padding: 0px !important;
      margin: 0px !important;

      li {
        list-style: none;
      }

      li.user-header {
        height: 243px;
        width: 300px;
        padding: 15px;
        border-radius: 5px 5px 0 0;
        text-align: center;
        background-color: #56A8FC;
        .el-avatar {
          border: 3px solid;
        }
        .avatar-uploader {
          width: 128px;
          height: 128px;
          margin: 0 auto;
          border-radius: 50%;
          border: 3px solid #f5f5f5;
        }
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409EFF;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 122px;
          height: 122px;
          line-height: 122px;
          text-align: center;
        }
        .avatar {
          width: 122px;
          height: 122px;
          border-radius: 50%;
          display: block;
        }

        p {
          z-index: 5;
          color: rgba(255, 255, 255, 0.9);
          font-size: 18px;
          margin-top: 10px;

          small {
            display: block;
            font-size: 12px;
          }
        }
      }

      li.user-footer {
        background-color: #eee;
        padding: 10px;
        clear: both;
        .pull-left {
          float: left !important;
        }
        .pull-right {
          float: right !important;
        }
      }
      li.user-footer::after,li.user-footer::before {
        content: " ";
        clear: both;
        display: table;
      }
    }
  }
</style>
